<!-- <app-adminheader></app-adminheader> -->
<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>

<div class="dash">
  <div class="row">
    <div [class.spinner]="loading"></div>
    <div class="col-lg-3 col-md-4 col-sm-12">
      <div class="admin-card" (click)="GoToTruck()">
        <img src="../../../assets/img/admin-trucks.svg" />
        <h4>Trucks</h4>
        <h3 (click)="GoToTruck()">{{ dashboardArray.trucks }}</h3>
      </div>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-12">
      <div class="admin-card" (click)="GoToTrips()">
        <img src="../../../assets/img/admin-trips.svg" />
        <h4>Trips</h4>
        <h3 (click)="GoToTrips()">{{ dashboardArray.trips }}</h3>
      </div>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-12">
      <div class="admin-card" (click)="GoToUsers()">
        <img src="../../../assets/img/admin-users.svg" />
        <h4>Standard Users</h4>
        <h3 (click)="GoToUsers()">{{ dashboardArray.customers }}</h3>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-3 col-md-4 col-sm-12">
      <div class="admin-card" (click)="GoToTruckOwner()">
        <img src="../../../assets/img/admin-truck-owner.svg" />
        <h4>Truck Owners</h4>
        <h3 (click)="GoToTruckOwner()">{{ dashboardArray.truckowners }}</h3>
      </div>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-12">
      <div class="admin-card" (click)="GoToAdmin()">
        <img src="../../../assets/img/admin-admin-users.svg" />
        <h4>Admin Users</h4>
        <h3 (click)="GoToAdmin()">{{ dashboardArray.adminUsers }}</h3>
      </div>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-12">
      <div class="admin-card" (click)="GoToDrivers()">
        <img src="../../../assets/img/admin-admin-users.svg" />
        <h4>Drivers</h4>
        <h3 (click)="GoToDrivers()">{{ dashboardArray.driver }}</h3>
      </div>
    </div>
  </div>
  <div class="row version-container">
    <div class="col-12 text-center">
      <div class="version-info">
        <span class="version-tag">
          Web Version: <strong>{{ webVersion }}</strong>
        </span>
        <span class="version-separator">|</span>
        <span class="version-tag">
          Backend Version: <strong>{{ backendVersion ? backendVersion : 'Loading...' }}</strong>
        </span>
      </div>
    </div>
  </div>
</div>
